import React, { useState , useEffect} from 'react';
import styles from './addStagesModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import StageDetailsConfiguration from './stageDetailsConfiguration';
import Review from './review';
import AddReviewCriteria from './reviewCriteria';

const AddStagesModal = (props) => {

    // let [noReviewCriteria,setNoReviewCriteria] = useState(false);
    let [step, setStep] = useState(1);
    let [reviewCriteria, setReviewCriteria] = useState({
        reviewCriteria: [
            {
                label: 'Educational qualifications',
            },
            {
                label: 'Professional qualifications',
            },
            {
                label: 'Leadership skills',
            },
            {
                label: 'Communication skills',
            },
            {
                label: 'Work experience',
            }
        ],
    })
    let [values, setValues] = useState({
        pipeline: props.pipelineID,
        stageName: '',
        stageType: '',
        description: '',
        interview_guidelines_to_candidate: '',
        numReviewer: 1,
        score: '',
        keywords: [],
        keywordToBeAdded: '',
        keywordCount: 0,
        assessment_body: '',
        assessment_exp_date: '',
        quiz_exp_date: '',
        quiz_template: null,
        assessment_reviewers:null,
        reference_check_reviewers:null,
        custom_evaluation_reviewers:null,
        custom_evaluation_description: '',
        one_way_interview_reviewers:null,
        interview_exp_in:'',
        one_way_interview_template: null,
        min_no_of_references_required:'',
        guide_for_candidates:'',

    })
    let [noOfReviewers, setNoOfReviewers] = useState(1);
    let [currentDropValue, setCurrentDropValue] = useState(1);

    function nextPage(value) {
        setStep(value)

    }
    function previousPage(value) {
        setStep(value)
    }

    function setAddReviewCriteria(values) {
        setReviewCriteria((prevState) => ({
            ...prevState,
            reviewCriteria: values.reviewCriteria,
        }))
    }

    function setSubmitValues(values) {
     
        setValues((prevState) => ({
            ...prevState,
            stageName: values.stageName,
            stageType: values.stageType,
            description: values.vacancyDesc,
            interview_guidelines_to_candidate: values.guidelineDescription,
            numReviewer: values.numReviewer,
            score: values.score,
            reviewers: values.reviewers,
            assessment_reviewers: values.assessment_reviewers,
            quiz_template: values.quiz_template,
            keywords: values.keywords,
            keywordCount: values.keywordCount,
            assessment_body: values.assessment_body,
            assessment_exp_date: values.assessment_exp_date,
            quiz_exp_date: values.quiz_exp_date,
            reference_check_reviewers: values.reference_check_reviewers,
            min_no_of_references_required: values.min_no_of_references_required,
            guide_for_candidates: values.guide_for_candidates,
            custom_evaluation_reviewers: values.custom_evaluation_reviewers,
            custom_evaluation_description: values.evaluationDescription,
            one_way_interview_reviewers: values.one_way_interview_reviewers,
            interview_exp_in: values.interview_exp_in,
            one_way_interview_template: values.one_way_interview_template,
            is_auto_request_referee_details_from_candidate_enabled: values.is_auto_request_referee_details_from_candidate_enabled
        }))
    }

    function setNumReviewers(value) {
        setNoOfReviewers(value);
    }

    function setDropValue(value) {
        setCurrentDropValue(value);
    }
    useEffect(() => {
        const existingLabels = new Set();

        let data = props.values;
        const normalizeLabel = (label) => label.toLowerCase().replace(/\s+/g, '');

        const removeDuplicateLabels = (respond) => {
            respond.forEach(stage => {
                if (stage.type_specific_parameters && stage.type_specific_parameters.review_criteria) {
                    const criteria = stage.type_specific_parameters.review_criteria;
                    stage.type_specific_parameters.review_criteria = criteria.filter(item => {
                        const normalizedLabel = normalizeLabel(item.label);
                        if (existingLabels.has(normalizedLabel)) {
                            return false;
                        } else {
                            existingLabels.add(normalizedLabel);
                            return true;
                        }
                    });
                    
                }
            });

            const uniqueLabels = Array.from(existingLabels).map(label => {
                return respond.find(stage => 
                    stage.type_specific_parameters && 
                    stage.type_specific_parameters.review_criteria &&
                    stage.type_specific_parameters.review_criteria.find(item => normalizeLabel(item.label) === label)
                )?.type_specific_parameters.review_criteria.find(item => normalizeLabel(item.label) === label)?.label;
            }).filter(label => label !== undefined);
            
            if (uniqueLabels.length > 0) {
                setReviewCriteria(prevState => ({
                    ...prevState,
                    reviewCriteria: uniqueLabels.map(label => ({ label })),
                }));
            }
            
            
        };
        removeDuplicateLabels(data);
    }, []); 
    

    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >

                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Add Evaluation Step</h2>
                        <p className={styles.documentLink}  ><a href='https://hiretrace.io/documentation/hiring-pipeline/add-evaluation-steps-to-pipeline' target="_blank">Learn more <i class="fas fa-external-link-alt"></i></a></p>
                    </div>

                    <Col xs={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                    <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : step === 3 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv3}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>
                                {
                                    step === 1 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_613_29628)">
                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_613_29628">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                }
                            </div>
                            <div className={(step === 2) || (step === 3) ? styles.stepActive : ''}>
                                {
                                    step === 2 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 2) || (step === 3)  ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                            <div className={(step === 3) || (step === 4) || (step === 5) || (step === 6) ? styles.stepActive : ''}>
                                {
                                    step === 3 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 3) || (step === 4) || (step === 5) || (step === 6) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                            
                          
                            
                           
                           
                        </div>
                    </Col>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Step Configurations':
                                    step === 2 ? 'Add Review Criteria'
                                        : 'Review'
                                }
                            </p>
                            <hr className={styles.subTopicDivider} />
                        </Container>
                    </Col>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            {/* Rendering Content Goes Here */}
                            {step === 1 && props.showModal === true && <StageDetailsConfiguration nextPage={nextPage} setSubmitValues={setSubmitValues} values={values} setNumReviewers={setNumReviewers} setDropValue={setDropValue} noOfReviewers={noOfReviewers} currentDropValue={currentDropValue} />}
                            {step === 2 && props.showModal === true && <AddReviewCriteria previousPage={previousPage} nextPage={nextPage} setAddReviewCriteria={setAddReviewCriteria} pipelineValues={reviewCriteria} values={values} />}
                            {step === 3 && props.showModal === true && <Review nextPage={nextPage} previousPage={previousPage} values={values} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} pipelineValues={reviewCriteria} />}
                        </Container>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default AddStagesModal;